import React, { createContext, useState, useEffect, useContext } from "react";
import axios from "axios";

const BACKEND_URL = "https://time-tracker-gx97.onrender.com";
export const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    try {
      const token = localStorage.getItem("token");
      const storedUser = localStorage.getItem("user");

      if (token && storedUser) {
        setUser(JSON.parse(storedUser));
      }
    } catch (err) {
      console.error("AuthProvider init error:", err);
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    try {
      const res = await axios.post(`${BACKEND_URL}/api/auth/login`, { email, password });

      if (res.data.token) {
        setUser(res.data.user);
        localStorage.setItem("token", res.data.token);
        localStorage.setItem("user", JSON.stringify(res.data.user));
        return { success: true };
      }

      return { success: false, msg: res.data.msg };
    } catch (err) {
      return { success: false, msg: err.response?.data?.msg || "Login failed" };
    }
  };

  const register = async (name, email, password) => {
    try {
      const res = await axios.post(`${BACKEND_URL}/api/auth/register`, { name, email, password });

      if (res.data.token) {
        setUser(res.data.user);
        localStorage.setItem("token", res.data.token);
        localStorage.setItem("user", JSON.stringify(res.data.user));
        return { success: true };
      }

      return res.data;
    } catch (err) {
      return { success: false, msg: err.response?.data?.msg || "Registration failed" };
    }
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setUser(null);
  };

  /**
   * Updates the current user in context and localStorage
   * Use this after profile updates to reflect changes in forms and navbar
   */
  const updateUser = (updatedUser) => {
    // Merge existing user data with new data to avoid null fields
    const mergedUser = { ...user, ...updatedUser };
    setUser(mergedUser);
    localStorage.setItem("user", JSON.stringify(mergedUser));
  };

  const value = { user, login, register, logout, loading, updateUser };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};